import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const GPSVendorList=React.lazy(()=>import('./List'));
const GPSVendorCreate=React.lazy(()=>import('./CreateForm'));

export const GpsConfig = [
  {
    permittedRole: [RoutePermittedRole.corporateAdmin,RoutePermittedRole.vendor],
    path: '/master/gps-vendor/create',
    element: <GPSVendorCreate />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/master/gps-vendor/list',
    element: <GPSVendorList/>,
  },
 

];
